import { FC, useCallback, useEffect, useRef, useState } from "react";

import { AiOutlineLoading } from "react-icons/ai";
import { useDebouncedCallback } from "use-debounce";

import "./LiveSearch.scss";

type Result = {
    name: string,
    type: string,
    id: string,
    url: string
}

interface LiveSearchProps {
    results: Result[],
    iRef: any,
    loading?: boolean,
    onChange?: any,
    onSelect: any
};

const LiveSearch = ( { results = [], iRef, onChange, loading, onSelect }: LiveSearchProps ) => {


    const [focusedIndex, setFocusedIndex] = useState(-1);
    const resultContainer = useRef<HTMLDivElement>(null);
    const [showResults, setShowResults] = useState(false);
    const [defaultValue, setDefaultValue] = useState("");


    const debouncedOnChange = useDebouncedCallback((e) => {
        onChange(e);
    }, 500);

    const handleSelection = (selectedItem: Result ) => {
        if (!selectedItem) return resetSearchComplete();

        onSelect && onSelect(selectedItem);
        resetSearchComplete();
    };

    const resetSearchComplete = useCallback(() => {
        setFocusedIndex(-1);
        setShowResults(false);
    }, []);

    const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
        const { key } = e;
        let nextIndexCount = 0;

        if (key === "ArrowDown")
            nextIndexCount = (focusedIndex + 1) % results.length;

        if (key === "ArrowUp")
            nextIndexCount =
                (focusedIndex + results.length - 1) % results.length;

        if (key === "Escape") {
            resetSearchComplete();
        }

        if (key === "Enter") {
            e.preventDefault();
            handleSelection(results[focusedIndex]);
        }

        setFocusedIndex(nextIndexCount);
    };


    useEffect(() => {
        if (!resultContainer.current) return;

        resultContainer.current.scrollIntoView({
            block: "center",
        });
    }, [focusedIndex]);

    useEffect(() => {
        if (results.length > 0 && !showResults) setShowResults(true);
        if (results.length <= 0 && !loading) setShowResults(false);
    }, [results]);

    useEffect(() => {
        console.log("results changed.")
        console.log(results);
    }, [results]);


    return (
        <>
            <input
                ref={iRef}
                onDoubleClick={() => console.log(defaultValue)}
                // value={defaultValue}
                onChange={debouncedOnChange}
                onKeyDown={handleKeyDown}
                type="text"
                className="searchInput"
            />

            {(showResults && !loading && iRef.current && iRef.current.value ) && (
                <div className="searchResultsContainer">
                    {
                        ((results.length > 0) && (
                            results.map((item: Result, index) => {
                                return (
                                    <div
                                        key={index}
                                        onClick={() => {
                                            console.log(`Selecting ${item.name}`);
                                            console.log(item);
                                            handleSelection(item)}}
                                        ref={
                                            index === focusedIndex
                                                ? resultContainer
                                                : null
                                        }
                                        style={{
                                            backgroundColor:
                                                index === focusedIndex
                                                    ? "rgba(0,0,0,0.35)"
                                                    : "",
                                        }}
                                        className="searchResultItem"
                                    >
                                        <span className="name">{item.name}</span>
                                        <span className={`type ${item.type}`}>{item.type}</span>
                                    </div>
                                );
                            })
                        ))
                    }
                </div>
            )}
            {
                (loading ? (
                    <div className="searchResultsLoader">
                        <AiOutlineLoading />
                    </div>
                ) : (
                    <></>
                ))
            }
            {
                (!loading && results.length <= 0 && iRef.current && iRef.current.value) && (
                    <div className="searchResultsLoader noResults">
                        No results found.
                    </div>
                )
            }
        </>
    );
};

export default LiveSearch;
